import "./LoadingSpinner.css";

type LoadingSpinnerProps = {
  className?: string;
};

export function LoadingSpinner({ className = "" }: LoadingSpinnerProps) {
  return (
    <span
      aria-hidden="true"
      className={`react-pdp__spinner${className ? ` ${className}` : ""}`}
    />
  );
}
